import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'role'
})

export class RolePipe implements PipeTransform {
    transform(value: any, el?) {
        // console.log('el: ', el.isTenPercentOwner);
        let val;
        switch (value) {
            case '0':
            case 'false':
            case '':
            case undefined:
                val = 'No';
                break;
            case '1':
            case 'true':
                val = 'Yes';
                break;

            default:
                break;
        }

        return val;
    }
}
